export const tourData = [
  {
    id: 1,
    city: 'new york',
    img: './img/newyork.jpeg',
    name: 'new york bridge tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 2,
    city: 'paris',
    img: './img/paris.jpeg',
    name: 'paris lights tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 3,
    city: 'london',
    img: './img/london.jpeg',
    name: 'london royal palace tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 4,
    city: 'tokyo',
    img: './img/tokyo.jpeg',
    name: 'tokyo sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 5,
    city: 'belgium',
    img: './img/belgium.jpg',
    name: 'belgium sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 6,
    city: 'chicago',
    img: './img/chicago.jpg',
    name: 'chicago sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 7,
    city: 'china',
    img: './img/china.jpg',
    name: 'china sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 8,
    city: 'england',
    img: './img/england.jpg',
    name: 'england sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 9,
    city: 'france',
    img: './img/france.jpg',
    name: 'france sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 10,
    city: 'germany',
    img: './img/germany.jpg',
    name: 'germany sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 11,
    city: 'israel',
    img: './img/isreal.jpg',
    name: 'israel sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 12,
    city: 'japan',
    img: './img/japan.jpg',
    name: 'japan sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 13,
    city: 'kansas',
    img: './img/kansas.jpg',
    name: 'kansas sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 14,
    city: 'korea',
    img: './img/korea.jpg',
    name: 'korea sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 15,
    city: 'nigeria',
    img: './img/nigeria.jpg',
    name: 'nigeria sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 16,
    city: 'switzerland',
    img: './img/switzerland.jpg',
    name: 'switzerland sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
  {
    id: 17,
    city: 'vietnam',
    img: './img/vietnam.jpg',
    name: 'vietnam sushi tour',
    info: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Tenetur, nam omnis error corrupti eum assumenda enim odit architecto corporis. Sequi',
  },
]
